<template>
  <div>
    <el-row class="flex">
      <el-col :span="16">
        <el-card class="" style="position: relative; height: 100%">
          <div slot="header" class="tui-cardTitle">
            <span>智慧管理</span>
          </div>
          <div class="flex-around">
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="flex-center" style="padding-bottom: 0.45rem">
                  <div class="tui-bottomTitle">书盒子</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in boxList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex-items" style="padding: 0.25rem 0"></div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in boxListBottom"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tui-border"></div>
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="flex-center" style="padding-bottom: 0.45rem">
                  <div class="tui-bottomTitle">测、培、评</div>
                </div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in textList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex-items" style="padding: 0.25rem 0"></div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 3); margin: 0"
                    v-for="(item, index) in textListBottom"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" style="margin-left: 0.25rem">
        <el-card>
          <div slot="header" class="tui-cardTitle">
            <span>幼儿成长</span>
          </div>
          <div class="tui-bottomTitle" style="padding: 0 0 0.25rem 0">
            绘本课程
          </div>
          <div class="flex">
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 2); margin: 0"
                    v-for="(item, index) in growList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tui-border" style="height: 0.875rem"></div>
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 2); margin: 0"
                    v-for="(item, index) in growListBottom"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <el-card style="margin-top: 0.25rem">
          <div slot="header" class="tui-cardTitle">
            <span>家长课程</span>
          </div>
          <div class="tui-bottomTitle" style="padding: 0 0 0.25rem 0">
            视频资源
          </div>
          <div class="flex">
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <!-- <div class="flex-center" >
                  <div class="tui-bottomTitle">书盒子</div>
                </div> -->
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 2); margin: 0"
                    v-for="(item, index) in videoList"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tui-border" style="height: 0.875rem"></div>
            <div class="flex" style="flex-direction: column; flex: 1">
              <div>
                <!-- <div class="flex-center" >
                  <div class="tui-bottomTitle">测、培、评</div>
                </div> -->
                <div class="tui-right">
                  <div
                    class="tui-rightItem"
                    style="width: calc(100% / 2); margin: 0"
                    v-for="(item, index) in videoListBottom"
                    :key="index"
                  >
                    <div class="flex-items tui-rightItemBox" style="padding: 0">
                      <p class="tui-Num">{{ item.Detail }}</p>
                      <p class="tui-desc">{{ item.Name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  GetTeacherBookInfo,
  GetTeacherTestInfo,
  GetStudentGrowInfo,
  GetParentGrowInfo,
} from "../../api/api";

export default {
  data() {
    return {
      boxList: [],
      boxListBottom: [],
      textList: [],
      textListBottom: [],
      growList: [],
      growListBottom: [],
      videoList: [],
      videoListBottom: [],
    };
  },
  created() {
    this.GetTeacherBookInfo();
    this.GetTeacherTestInfo();
    this.GetStudentGrowInfo();
    this.GetParentGrowInfo();
  },
  methods: {
    async GetParentGrowInfo() {
      let res = await GetParentGrowInfo();
      if (res.data.success) {
        this.videoList = res.data.response.splice(0, 2);
        this.videoListBottom = res.data.response.splice(0, 4);
      }
    },
    async GetTeacherBookInfo() {
      let res = await GetTeacherBookInfo();
      if (res.data.success) {
        this.boxList = res.data.response.splice(0, 3);
        this.boxListBottom = res.data.response.splice(0, 6);
      }
    },
    async GetTeacherTestInfo() {
      let res = await GetTeacherTestInfo();
      if (res.data.success) {
        this.textList = res.data.response.splice(0, 3);
        this.textListBottom = res.data.response.splice(0, 6);
      }
    },
    async GetStudentGrowInfo() {
      let res = await GetStudentGrowInfo();
      if (res.data.success) {
        this.growList = res.data.response.splice(0, 2);
        this.growListBottom = res.data.response.splice(0, 4);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.seamless-warp {
  height: 2rem;
  overflow: hidden;
  margin-top: 0.15rem;
}
.tui-taskTitle {
  font-size: 0.175rem;
  font-weight: 500;
  padding: 0.125rem 0 0 0;
}
.tui-task/deep/.el-card__header {
  background: #fff8f0;
}
.tui-progressTitle {
  font-size: 0.3rem;
  font-weight: 600;
  padding-right: 0.125rem;
  flex-shrink: 0;
}
.tui-progressResult {
  font-size: 0.225rem;
  color: #666;
  font-weight: 500;
  padding-left: 0.125rem;
  flex-shrink: 0;
}
.tui-progress {
  width: 4.2125rem;
  height: 0.25rem;
  background: rgba(143, 156, 253, 0.28);
  border-radius: 0.1375rem;
  position: relative;
  div {
    position: absolute;
    left: 0;
    background: #8f9cfd;
    height: inherit;
    border-radius: 0.1375rem;
  }
}
/deep/.el-input__inner {
  width: 162px;
  height: 38px;
  border-radius: 20px;
  color: #333;
}
.tui-headerTitle {
  font-size: 28px;
  font-weight: 500;
}
.tui-border {
  width: 1px;
  height: 3.2375rem;
  border: 1px solid #ededed;
  // margin-right: 0.4375rem;
}
.tui-bottomTitle {
  font-size: 0.25rem;
  font-weight: 500;
  text-align: center;
}
.tui-before {
  width: 0.075rem;
  height: 0.2375rem;
  background: #5e99ff;
  border-radius: 3px;
  margin-right: 0.125rem;
}
.tui-margin {
  margin: 0 0 0 0.25rem !important;
}
.tui-nutrition {
  font-size: 0.2rem;
  color: #333;
  font-weight: bold;
  padding-top: 1rem;
  padding-left: 1.325rem;
  span {
    font-size: 0.45rem;
    color: #e02020;
    font-weight: bold;
    padding-left: 0.275rem;
  }
}
.box-card {
  height: 4.375rem;
}
.tui-details {
  position: absolute;
  bottom: 0.25rem;
  right: 0.25rem;
  display: flex;
  align-items: center;
  color: #4083fe;
  font-size: 0.175rem;
}
.tui-sexTab {
  display: flex;
  flex-direction: column;
  .tui-sexTabItem {
    width: 1.45rem;
    height: 0.375rem;
    border-radius: 3px;
    border: 1px solid #cdcdcd;
    font-size: 0.175rem;
    color: #333;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 0.25rem 0;
  }
  .tui-sexTabItemActive {
    background: #cbd6ff;
    font-weight: bold !important;
  }
}
.tui-healthLeft::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.tui-healthLeft::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #9d9d9d;
  opacity: 1;
}

.tui-healthLeft::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.tui-healthLeftActive {
  background: #cbd6ff;
}
.tui-healthLeft {
  width: 1.875rem;
  height: 2.825rem;
  border-radius: 0.1875rem;
  border: 1px solid #cdcdcd;
  overflow-y: scroll;
  div {
    cursor: pointer;
    width: 1.2375rem;
    height: 0.3375rem;
    font-size: 0.175rem;
    font-weight: 500;
    color: #333;
    margin: 0.25rem auto;
    // padding: 0.25rem 0;
    text-align: center;
    border-radius: 0.25rem;
  }
}
.tui-cardTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.275rem;
  font-weight: 600;
  color: #333;
}
.tui-right {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  .tui-rightItem {
    width: calc(100% / 5);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.625rem;
    img {
      width: 0.825rem;
      height: 0.825rem;
    }
    .tui-rightItemBox {
      flex-direction: column;
      padding-left: 0.325rem;
      .tui-Num {
        font-size: 0.4rem;
        font-weight: 500;
        color: #333;
      }
      .tui-desc {
        font-size: 0.15rem;
        font-weight: 500;
        color: #333;
        // padding-top: 0.175rem;
      }
    }
  }
}
.tui-left {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .tui-leftContent {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tui-leftTitle {
      font-size: 0.25rem;
      color: #333;
      font-weight: 600;
      padding-bottom: 0.6625rem;
    }
    .tui-leftBtn {
      width: 0.9rem;
      height: 0.4125rem;
      background: linear-gradient(172deg, #f0f3ff 0%, #d4ddff 100%);
      box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 1);
      border-radius: 0.2125rem;
      border: 1px solid #0b22b3;
      font-size: 0.25rem;
      color: #0b22b3;
      font-weight: 500;
    }
    .tui-leftDesc {
      font-size: 0.175rem;
      font-weight: 500;
      padding-top: 0.125rem;
    }
  }
}
</style>